module.exports = __webpack_public_path__ + "static/img/tcqn2.3e41f1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tcqn2.png
// module id = 381
// module chunks = 0